import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { queries } from '../../../../../../shared/queries';
import { AxiosCommonError } from '../../../../../../shared/types';
import { handleError } from '../../../../../ui/err/handleError';

export default function useGetExtendHistory(params: { mac: string }) {
  return useQuery({
    ...queries.devices.extendHistory(params),
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
